// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__UgfxY","radioRow":"SimpleQuestionBuilderModal_radioRow__3YvCo"};